import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  changePasswordButton: {
    textTransform: 'none',
    fontWeight: 400,
  },
}))
